import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const REGIONI = [
  'Abruzzo','Basilicata','Calabria','Campania','Emilia','Friuli','Lazio','Liguria',
  'Lombardia','Marche','Molise','Piemonte','Puglia','Sardegna','Sicilia','Toscana',
  'Trentino Alto Adige','Umbria',"Valle D'Aosta",'Veneto'
]

export default function AdminCompagnie() {
  const [comp, setComp] = useState([])
  const [edits, setEdits] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const { data } = await supabase.from('compagnie').select('*').order('ordine')
    setComp(data || [])
    setLoading(false)
  }

  async function save(codice) {
    const patch = edits[codice]; if (!patch) return
    await supabase.from('compagnie').update(patch).eq('codice', codice)
    setEdits(e => { const x={...e}; delete x[codice]; return x })
    load()
  }

  function setField(codice, k, v) {
    setEdits(e => ({ ...e, [codice]: { ...(e[codice]||{}), [k]: v }}))
  }

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header">
        <h1>Compagnie</h1>
        <p>Gestione catalogo compagnie comparabili. EIR è l'unica con tariffa reale, le altre sono placeholder finché non si caricano i tassi.</p>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>Codice</th><th>Nome</th><th>Categoria</th><th>Attiva</th><th>Placeholder</th><th>Regioni incluse</th><th>Regioni escluse</th><th>Ord.</th><th></th></tr>
            </thead>
            <tbody>
              {comp.map(c => {
                const e = edits[c.codice] || {}
                const v = (k) => e[k] !== undefined ? e[k] : c[k]
                const dirty = Object.keys(e).length > 0
                return (
                  <tr key={c.codice}>
                    <td><strong>{c.codice}</strong></td>
                    <td><input value={v('nome')||''} onChange={x => setField(c.codice,'nome',x.target.value)} /></td>
                    <td>
                      <select value={v('categoria')} onChange={x => setField(c.codice,'categoria',x.target.value)}>
                        <option value="dealer">Dealer</option>
                        <option value="annuale">Annuale</option>
                        <option value="standalone">Stand alone</option>
                      </select>
                    </td>
                    <td><input type="checkbox" checked={!!v('attiva')} onChange={x => setField(c.codice,'attiva',x.target.checked)} /></td>
                    <td><input type="checkbox" checked={!!v('placeholder')} onChange={x => setField(c.codice,'placeholder',x.target.checked)} /></td>
                    <td><MultiSelect value={v('regioni_incluse')||[]} onChange={vv => setField(c.codice,'regioni_incluse',vv)} /></td>
                    <td><MultiSelect value={v('regioni_escluse')||[]} onChange={vv => setField(c.codice,'regioni_escluse',vv)} /></td>
                    <td><input type="number" value={v('ordine')||100} onChange={x => setField(c.codice,'ordine',parseInt(x.target.value))} style={{ width: 60 }} /></td>
                    <td>{dirty && <button className="btn btn-sm btn-primary" onClick={() => save(c.codice)}>Salva</button>}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

function MultiSelect({ value, onChange }) {
  const set = new Set(value)
  function toggle(r) {
    const s = new Set(set); if (s.has(r)) s.delete(r); else s.add(r); onChange(Array.from(s))
  }
  return (
    <select multiple value={value} onChange={() => {}} style={{ height: 80, fontSize: 12, minWidth: 160 }}>
      {REGIONI.map(r => (
        <option key={r} value={r} onClick={() => toggle(r)} style={{ background: set.has(r) ? '#EEEDFE' : 'white' }}>{r}</option>
      ))}
    </select>
  )
}
